export default "__VITE_ASSET__D2wcp7IV__"